// USED IN FLEXIBLE COLUMN CONTAINER BLOCK, EXTENDED SEARCH BLOCK

import Swiper from "swiper";
import { Navigation } from "swiper/modules";

import "swiper/css";

export default function SwiperTabsCarousel() {
  const swiperElement = document.querySelectorAll<HTMLDivElement>(".js-swiper-tabs-carousel");

  if (swiperElement && swiperElement.length > 0) {
    Swiper.use([Navigation]);

    swiperElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const carouselEl = el.querySelector<HTMLDivElement>(".swiper");
        const swiperWrapper = carouselEl?.querySelector<HTMLDivElement>(".swiper-wrapper");
        const direction = el.getAttribute("data-carousel-alignment");
        const slides = el.querySelectorAll<HTMLDivElement>(".swiper-slide");
        const nextBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-next");
        const prevBtn = el.querySelector<HTMLButtonElement>(".swiper-btn-prev");

        if (carouselEl) {
          if (direction === "left") {
            if (slides && slides.length > 7) {
              new Swiper(carouselEl, {
                direction: "vertical",
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                slidesPerView: 7,
                spaceBetween: 20,
              });
            }
          } else {
            let totalSlidesWidth = 0;
            const containerWidth = carouselEl.offsetWidth - 80;

            slides.forEach((item) => {
              const btn = item.querySelector("button");

              if (btn) {
                item.style.width = `${btn.offsetWidth}px`;
              }
            });

            slides.forEach(slide => {
              totalSlidesWidth += slide.offsetWidth;
            });

            if (totalSlidesWidth > containerWidth) {
              if(swiperWrapper) swiperWrapper.style.justifyContent = "left"
              if (nextBtn) nextBtn.style.display = "flex";
              if (prevBtn) prevBtn.style.display = "flex";
              
              new Swiper(carouselEl, {
                loop: false,
                navigation: {
                  nextEl: nextBtn,
                  prevEl: prevBtn,
                },
                slidesPerView: "auto",
                spaceBetween: 6,
              });
            } else { 
              
              if ((carouselEl as any).swiper) {
                (carouselEl as any).swiper.destroy(true, true);
              }
              
              if (nextBtn) nextBtn.style.display = "none";
              if (prevBtn) prevBtn.style.display = "none";
              
              if(swiperWrapper) {
                swiperWrapper.style.justifyContent = "center"
                swiperWrapper.style.gap = "6px"
              }
            }
          }
        }
      }
    });
  }  
}

 SwiperTabsCarousel()
window.addEventListener('resize', SwiperTabsCarousel);
